import { createReactExtension } from '@backstage/core-plugin-api';
import { homePlugin } from '@backstage/plugin-home';

export const PluginOrTemplateDecisionGuideWidget = homePlugin.provide(
  createReactExtension({
    name: 'PluginOrTemplateDecisionGuideWidget',
    component: {
      lazy: () =>
        import('../../contribute/decision-guide/decision-guide').then(
          m => m.DecisionGuide,
        ),
    },
    data: {
      'home.widget.config': {
        layout: {
          title: 'Plugin or Template Decision Guide',
          description:
            'Interactive guide to help you decide whether to build a Plugin or a Template.',
          width: { minColumns: 4 },
          height: { minRows: 2 },
        },
      },
    },
  }),
);
